import { useCallback, useSyncExternalStore } from 'react';
import type { SetStateAction } from 'react';
import type { InstructorPreferences } from '../instructor/types';

export const INSTRUCTOR_STORAGE_KEY='pulkra-instructor-v1';
export const defaultInstructorPreferences:InstructorPreferences={enabled:true,minimized:false,muted:true,captions:true,dismissedCueIds:[]};

const readInitial=():InstructorPreferences=>{try{return {...defaultInstructorPreferences,...JSON.parse(localStorage.getItem(INSTRUCTOR_STORAGE_KEY)||'{}')}}catch{return defaultInstructorPreferences}};

let state:InstructorPreferences=readInitial();
const listeners=new Set<()=>void>();
const subscribe=(listener:()=>void)=>{if(listeners.size===0)state=readInitial();listeners.add(listener);return()=>listeners.delete(listener)};
const getSnapshot=()=>state;
const setState=(action:SetStateAction<InstructorPreferences>)=>{
  const next=typeof action==='function'?(action as (value:InstructorPreferences)=>InstructorPreferences)(state):action;
  state=next;
  try{localStorage.setItem(INSTRUCTOR_STORAGE_KEY,JSON.stringify(next))}catch{/* preferences must never block learning */}
  for(const listener of listeners)listener();
};

export function useInstructorStore(){
  const preferences=useSyncExternalStore(subscribe,getSnapshot);
  const setPreferences=useCallback((action:SetStateAction<InstructorPreferences>)=>setState(action),[]);
  return {preferences,setPreferences};
}
